import React, { useEffect, useRef } from 'react';

const MainVisual: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // 모바일 환경에서도 autoplay 가능하게 설정
    const playVideo = async () => {
      try {
        await video.play();
      } catch (err) {
        console.log("Autoplay blocked, waiting for user interaction", err);
      }
    };

    playVideo();
  }, []);
  
  return (
    <section
      className="flex justify-center relative"
    >
      <video ref={videoRef} className="w-full h-full" src="/videos/main-visual.mp4" autoPlay loop muted playsInline />
      <div className="container px-10 flex flex-col justify-center z-10 absolute bottom-1/4 left-1/2 transform -translate-x-1/2 w-full">
        <h4 className="lg:text-[2.25rem] text-[1.5rem] text-white font-bold leading-[1.1]">
          이제 당신의 PT회원에게
          <br />
          한차원 높은 PT 서비스를 제공해보세요!
        </h4>
        <h5 className="mt-8 lg:text-[2.0rem] text-[1.5rem] text-white font-light">
          트레이너의 새로운 경쟁력, 원격피티 - <span className="font-medium">카운트핏</span>
        </h5>
      </div>
    </section>
  );
};

export default MainVisual;
